import axios from "axios";
import { UNAUTHORIZED } from "@/utils/Auth/authConstants";
import { getUserToken } from "@/utils/Auth/useUserSfId";


const getPreviousSchool = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_GET_APPLICATION_FORM,
  headers: {
    "Content-Type": "application/json",
    "Content-Security-Policy":
      "default-src 'self'; script-src 'self' 'unsafe-inline'; style-src 'self' 'unsafe-inline'; img-src 'self' data:; object-src 'none'",
  },
});

getPreviousSchool.interceptors.request.use(
  (config) => {
    const accessTokens = getUserToken();
    if (accessTokens) {
      config.headers.Authorization = `Bearer ${accessTokens}`;
    }else{
      console.log("Token N/A");
    }
    return config;
  },
  (error) => {
    console.log("Request error:", error);
    return Promise.reject(error);
  }
);


getPreviousSchool.interceptors.response.use(
  async (response) => {
    return response?.data;
  },
  async (error) => {
    console.error("Response error:", error);
    if (error.response.status === 401 || error.response.status === 403) {
      return UNAUTHORIZED;
    }
    return Promise.reject(error);
  }
);

export default getPreviousSchool;
